// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"eca6988a","424":"df92eccc","448":"a7078f01","512":"e7985d9e","644":"8c235118","748":"fa16a074"}[chunkId] + ".chunk.js";
};